// Перенесено из блока «Class packages» сайта (lingva-pro-site-2, PackagesSection).
// Три пакета; ссылки Stripe — отдельные для кабинета (не сайтовые), к ним
// добавляется client_reference_id. Источник истины по составу пакета — сама ссылка
// Stripe. Занятие 60 минут, цена одна для всех направлений.
export const packages = [
  {
    id: 'classes-13',
    classes: 13,
    price: '$750',
    perClass: '≈ $58',
    stripeUrl: 'https://buy.stripe.com/aFa3cw0u4cZz6fM8xFaZk1f',
  },
  {
    id: 'classes-25',
    classes: 25,
    price: '$1150',
    perClass: '$46',
    save: 20,
    stripeUrl: 'https://buy.stripe.com/7sY7sMgt22kV0VsaFNaZk1e',
  },
  {
    id: 'classes-60',
    classes: 60,
    price: '$1800',
    perClass: '$30',
    save: 48,
    stripeUrl: 'https://buy.stripe.com/9B614oekU9Nnaw2aFNaZk1d',
    highlight: true,
  },
];

// Способы оплаты, которые предлагает checkout Stripe. Google Pay назван в тексте
// под значками: Stripe показывает его только в Chrome и на Android.
export const paymentMethods = [
  { id: 'visa', name: 'Visa', file: '/images/payments/visa.svg' },
  { id: 'mastercard', name: 'Mastercard', file: '/images/payments/mastercard.svg' },
  { id: 'amex', name: 'American Express', file: '/images/payments/amex.svg' },
  { id: 'unionpay', name: 'UnionPay', file: '/images/payments/unionpay.svg' },
  { id: 'apple-pay', name: 'Apple Pay', file: '/images/payments/apple-pay.svg' },
  { id: 'klarna', name: 'Klarna', file: '/images/payments/klarna.svg' },
  { id: 'afterpay', name: 'Afterpay', file: '/images/payments/afterpay.svg' },
];

export const TERMS_URL = 'https://lingva-pro.org/terms';
// Телефон поддержки: страница оплаты и баннер «мало уроков» в кабинете
export const SUPPORT_PHONE = { label: '+1 (516) 716-8273', href: 'tel:+15167168273' };

// Ссылка Stripe с id контакта из CRM: по client_reference_id платёж сопоставляется с учеником.
export function withClientReference(url, userId) {
  return `${url}?client_reference_id=${encodeURIComponent(userId)}`;
}
